import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuintileDistribution;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
/* eslint "no-mixed-operators": "warn" */
import { Component } from 'react';
import { PropTypes } from 'prop-types';
import { jsx, css } from '@instructure/emotion';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Table } from '@instructure/ui-table';
import t from '@instructure/quiz-i18n/es/format-message';
import Distribution from '../Distribution';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var QuintileDistribution = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuintileDistribution = /*#__PURE__*/function (_Component) {
  function QuintileDistribution() {
    var _this;
    _classCallCheck(this, QuintileDistribution);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, QuintileDistribution, [].concat(args));
    _defineProperty(_this, "_calculateAxis", function (_, _2, xAxis) {
      xAxis.tickFormat(_this.calculateLabelForIndex);
    });
    _defineProperty(_this, "calculateLabelForIndex", function (d) {
      var numBars = _this.props.visualDistribution.length;
      if (_this.props.calculateLabelForColumn) {
        return _this.props.calculateLabelForColumn(d, numBars);
      }
      var lower = Math.floor(d * 100 / numBars);
      var upper = Math.floor((d + 1) * 100 / numBars - (d < numBars - 1 ? 1 : 0));
      return t('{lower, number}-{upper, number}%', {
        lower: lower,
        upper: upper
      });
    });
    // updateChart
    _defineProperty(_this, "_renderNumbers", function (svg, x, y, applyTransition, barContainer, height) {
      var chartData = _this.props.visualDistribution;
      var numbers = barContainer.selectAll('text').data(chartData);
      var texts = numbers.enter().insert('text', 'rect').attr('style', css(_this.props.styles.barLabel).styles).text(function (d) {
        return d;
      }).attr('x', function (d, i) {
        return x(i) + x.bandwidth() / 2;
      });
      applyTransition(texts, function (texts) {
        return texts.attr('y', height + 12);
      }, function (texts) {
        return texts.attr('y', function (d) {
          return y(d) - 6;
        });
      }, function (transition) {
        return transition.delay(function (d, i) {
          return (_this.props.animateDelay || 0) * (1 + i / _this.props.visualDistribution.length);
        });
      });
      numbers.exit().remove();
    });
    _defineProperty(_this, "_renderTable", function () {
      return jsx(ScreenReaderContent, null, jsx(Table, {
        caption: t('Score percentiles chart data')
      }, jsx(Table.Head, null, jsx(Table.Row, null, jsx(Table.ColHeader, {
        id: "score-percentiles-chart-data-score-percentile-range"
      }, t('Score Percentile Range')), jsx(Table.ColHeader, {
        id: "score-percentiles-chart-data-count"
      }, t('Count')))), jsx(Table.Body, null, _this.renderTableRows())));
    });
    return _this;
  }
  _inherits(QuintileDistribution, _Component);
  return _createClass(QuintileDistribution, [{
    key: "renderTableRows",
    value: function renderTableRows() {
      var _this2 = this;
      var chartData = this.props.visualDistribution;
      return chartData.map(function (count, index) {
        var label = _this2.calculateLabelForIndex(index);
        return jsx(Table.Row, {
          key: "".concat(label, ":").concat(count)
        }, jsx(Table.RowHeader, null, label), jsx(Table.Cell, null, count));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = Object.assign({}, this.props, {
        calculateAxis: this._calculateAxis,
        renderTable: this._renderTable,
        updateChart: this._renderNumbers
      });
      return jsx(Distribution, props);
    }
  }]);
}(Component), _defineProperty(_QuintileDistribution, "displayName", 'QuintileDistribution'), _defineProperty(_QuintileDistribution, "componentId", "Quizzes".concat(_QuintileDistribution.displayName)), _defineProperty(_QuintileDistribution, "propTypes", {
  animateDelay: PropTypes.number,
  animateDuration: PropTypes.number,
  barPaddingInner: PropTypes.number,
  // Spacing between bars, so each is visible, could be accomplished by borders
  barPaddingOuter: PropTypes.number,
  // Spacing between bars, so each is visible, could be accomplished by borders
  barPaddingTop: PropTypes.number,
  chartHeight: PropTypes.number.isRequired,
  // Height in pixels
  chartWidth: PropTypes.number,
  /* *
   * * a fallback minimal distribution for tab-able, keyboard navigable buckets
   * * typically this will be ~ 10 buckets
   * */
  summaryDistribution: PropTypes.arrayOf(PropTypes.node),
  /* *
   * * A list of score values for each bucket.  Size of this array determines the number of buckets
   * */
  visualDistribution: PropTypes.arrayOf(PropTypes.node).isRequired,
  /* *
   * * Callback with column index and columns quantity as arguments.
   * * Should return string which will be label for chart column.
   * * If undefined uses default column label calculation
   * */
  calculateLabelForColumn: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_QuintileDistribution, "defaultProps", {
  animateDelay: 200,
  animateDuration: 900,
  barPaddingInner: 0.375,
  barPaddingOuter: 0.1875,
  barPaddingTop: 24,
  chartHeight: 200,
  // Height in pixels
  chartWidth: void 0,
  summaryDistribution: void 0,
  visualDistribution: [],
  calculateLabelForColumn: null
}), _QuintileDistribution)) || _class);
export default QuintileDistribution;